import { useDispatch, useSelector } from "react-redux";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {getDiariosProducao} from "../../actions/i4Actions";
import DiariosProducaoMainView from "./DiarioProducaoMainView";


const useStyles = makeStyles(theme => ({

}));


const DiariosProducao = ({

                          }) => {
    const classes = useStyles();

    const dispatch = useDispatch();


    useEffect( () => {
        dispatch(getDiariosProducao());
    }, []);

    return (
     <React.Fragment>
            <DiariosProducaoMainView/>
     </React.Fragment>
    )

}

export default DiariosProducao;
